import { startOfDay, startOfWeek, startOfMonth, subMonths } from "date-fns";
import { fr } from "date-fns/locale";

export const getPeriodStart = (period: string) => {
  const now = new Date();
  switch (period) {
    case "today":
      return startOfDay(now);
    case "week":
      return startOfWeek(now, { locale: fr });
    case "month":
      return startOfMonth(now);
    case "3months":
      return startOfDay(subMonths(now, 3));
    default:
      return null;
  }
};